import React from "react";

import { useLocation } from "react-router-dom";

import MenuDeveloper from "../../../pages/nf-invoice/menu";
import Navbar from "../../navbar";
import ButtonWhatsApp from "../../button-whatsapp/ButtonWhatsApp";

import {
  ButtonsContainer,
  CenterContent,
  ContainerStyled,
  ContentStyled,
} from "./styles";

import { useAuthGlobal } from "../../../../contexts/auth-context/auth-context";

import VerbalizeNowIcon from "../../verbalize-now-icon";

import IProps from "./props";

const BaseLayout: React.FC<IProps> = ({ children }) => {
  const location = useLocation();

  const { user } = useAuthGlobal();

  React.useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://webchat.digisac.app/embedded.js";
    script.async = true;

    document.body.appendChild(script);
  }, []);

  const devPackage = user?.developerResponseDTO?.developerPackages[0]?.pack;
  const isAllowed =
    devPackage?.id === 3 || devPackage?.monthlyEnglishMentorship;

  return (
    <ContainerStyled>
      <MenuDeveloper />
      <ContentStyled>
        <Navbar />
        <CenterContent>{children}</CenterContent>
        <ButtonsContainer>
          {location.pathname !== "/profile" && (
            <VerbalizeNowIcon isAllowed={isAllowed} />
          )}
          <ButtonWhatsApp />
        </ButtonsContainer>
      </ContentStyled>
    </ContainerStyled>
  );
};

export default BaseLayout;
